export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - Lamborghini */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3be32e9b9d78ed76f95e5f34bae4f1ed.jpg"
          alt="Premium mobile detailing Miami - Lamborghini"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/80 to-black/70"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center lg:text-left">
        <div className="max-w-3xl">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 bg-yellow-500/20 border border-yellow-500/40 rounded-full px-4 py-2 mb-6">
            <span className="text-yellow-500 text-2xl">⭐⭐⭐⭐⭐</span>
            <span className="text-yellow-400 font-semibold text-sm">Trusted by Miami's Luxury Car Owners</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
            Premium Mobile Auto Detailing in 
            <span className="text-yellow-500 block mt-2">Miami & Surrounding Areas</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Miami Line Lux Detailing brings showroom-level results right to your driveway. We handle every inch of your vehicle with expert care so you can enjoy a car that looks, feels, and smells like new.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6">
            <a
              href="sms:+17863272644"
              className="bg-yellow-500 text-black px-10 py-5 rounded-full text-lg font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl shadow-yellow-500/40"
            >
              <i className="ri-message-3-line text-2xl"></i>
              Text Us for a Quote
            </a>
            <a
              href="https://wa.me/17863272644"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-green-500 transition-all inline-flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl shadow-green-600/40"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp Us
            </a>
          </div>

          {/* Sub-info */}
          <p className="text-gray-400 text-sm flex flex-wrap items-center justify-center lg:justify-start gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-smartphone-line text-yellow-500"></i>
              Fully mobile
            </span>
            <span>•</span>
            <span className="flex items-center gap-1">
              <i className="ri-map-pin-line text-yellow-500"></i>
              We come to you
            </span>
            <span>•</span>
            <span className="flex items-center gap-1">
              <i className="ri-car-washing-line text-yellow-500"></i>
              Interior & exterior detailing
            </span>
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-yellow-500 text-3xl"></i>
      </div>
    </section>
  );
}
